<template lang="pug">
    div
        Select(@on-change="selectExample")
            Option(
                v-for="(scroll, index) in examples" 
                :value="index" 
                :label="scroll.scrollName"
                :key="index" 
            )
</template>

<script>
import dedent from "dedent";
export default {
    name: "ScrollsFormExamples",
    components: {},
    data() {
        return {
            examples: [
                {
                    scrollName: "send_html",
                    scrollRaw: dedent`
                        module.exports = (req, res, next) => {
                            let headers = { "Content-Type": "text/html; charset=UTF-8" }
                            let body = '<p>Hello Ninja</p>'

                            res.headers(headers).send(body)
                        };
                    `,
                },
                {
                    scrollName: "send_json",
                    scrollRaw: dedent`
                        module.exports = (req, res, next) => {
                            let headers = { "Content-Type": "Application/json" }
                            let body = { "hello": "ninja" }

                            res.headers(headers).send(body)
                        };
                    `,
                },
                {
                    scrollName: "redirect",
                    scrollRaw: dedent`
                        module.exports = (req, res, next) => {
                            let status = '301'
                            let headers = { "Location": "https://google.com/" }

                            res.status(status).send()
                        }
                    `,
                },
                {
                    scrollName: "fetch_url",
                    scrollRaw: dedent`
                        module.exports = (req, res, next) => {
                            const https = require("https");
                            const url = "https://catfact.ninja/fact";
                        
                            https
                                .get(url, resp => {
                                    let data = "";
                        
                                    resp.on("data", chunk => {
                                        data += chunk;
                                    });
                        
                                    resp.on("end", () => {
                                        let headers = { "Content-Type": "Application/json" }
                                        let body = data

                                        res.headers(headers).send(body)
                                    });
                                })
                                .on("error", err => {
                                    let status = '409'
                                    let headers = { "Content-Type": "Application/json" }
                                    let body = data

                                    res.status(status).headers(headers).send(body)
                                });
                        };
                    `,
                },
            ],
        };
    },
    props: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
        selectExample(index) {
            // console.log(index);
            // console.log(this.examples[index]);
            this.$emit("selectExample", this.examples[index]);
        },
    },
    computed: {},
    beforeDestroy() {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Scrolls/FormExamples.vue